/** @format */

export const DEFAULT_TEST_ID = 'fan-hand';

export const FAN_ANGLE_STEP_DEGREES = 8;
